import React, { useEffect,useState } from 'react';
import {  Link,useNavigate } from 'react-router-dom';

import Input from '../input';
import Button from '../button';
import MessageDialog from '../messageDialog';
import LoadingOverlay from '../loadingOverlay';
import config from '../../config';
import { get, post, getBaseURL } from '../../request'
import './styles.scss';

function ForgetPasswordDialog({ onConfirm, onCancel, nextLink, isShow }) {
    var baseURL = getBaseURL();

    const [isLoading, setShowLoading] = useState(false);
    const [isDisable, setBtnDisable] = useState(true);
    const [formIsValid, setFormIsValid] = useState(false);
    const [varCodeImg, setVarCodeImg] = useState("");
    const [sessionId, setSessionId] = useState("");
    const [successMessage, setSuccessMessage] = useState("");
    const [errorMessage, setErrorMessage] = useState("");
    const [second, setSecond] = useState(60);
    const [paracont, setParacont] = useState("获取验证码");
    const [paraevent, setParaevent] = useState(true);

    const [item, setInputs] = useState({
        phone: '',
        password: '',
        passwordverfiy: '',
        varcode2: '',
        varcode: '',
        userType:1
    });
    const [isValid, setIsValid] = useState({
        phone: false,
        password: false,
        passwordverfiy: false,
        varcode2: false,
        varcode: false
    });

    useEffect(() => {
        getVarCodeImg();

    }, []);

    

    const handleInputChange = (name, value) => {
        setInputs({ ...item, [name]: value });
    };

    const hideDialog = () => {
        //setIsVisible(false);
        if (onCancel) {
            onCancel(false);
        }
    };
    const navigate = useNavigate();
    const handleClick = () => {
        //onConfirm();
        setSuccessMessage("");
        setErrorMessage("");
        setShowLoading(true);
        item.sessionId = sessionId;
        post('delianapi/user/modifypassword', item).then((response)=> {
            setShowLoading(false);
            if (response.statusCode !== 200) {
                setErrorMessage( response.message);
                return;
            }
            setSuccessMessage("修改密码成功！");
            hideDialog();
        });
       
    };

    const handleCancel = () => {
        //onCancel();
        hideDialog();
    };
    const handleValidInput = (name, isNewValid) => {
        setIsValid(isValid => {
            isValid[name] = isNewValid;
            return isValid;
        });
        validateForm();
    }
    const validateForm = () => {
        const timer = setTimeout(() => {
            const isAllFieldsFilled = Object.values(isValid).every(value => value);
            setFormIsValid(isAllFieldsFilled);
            clearTimeout(timer);
        }, 10);
    };
    const getVarCodeImg = () => {
        setShowLoading(true);
        post("delianapi/login/clearcodenew", { sessionId: sessionId }).then((response) => {
            setShowLoading(false);
            if (response.statusCode == 200 && response.items.length > 0) {
                setSessionId(response.items[0]);
                setVarCodeImg(baseURL + "/delianapi/login/code?sessionId=" + response.items[0] + "&width=" + 100 + "&height=" + 45 + "&v=" + Math.random());
            }

        });
    };
    const getNumber = () => {
        const intervalId = setInterval(() => {
            //setCount(prevCount => prevCount + 1);
            if (second <= 0) {
                clearInterval(intervalId);
                setSecond(60);
                setParacont("重发验证码");
                setParaevent(true);
            }
            else {
                setParacont(second + "秒后可重发");
                second = second - 1;
                setSecond(second);
                setParaevent(false);
            }
        }, 1000);
        // 清除定时器，避免在组件卸载后继续执行  
        //return () => clearInterval(intervalId);
    };
    const sendphonecode = () => {
        setShowLoading(true);
        get("delianapi/sms/code?sessionId=" + sessionId + "&phone=" + item.phone + '&varcode2=' + item.varcode2
            + '&t=' + Math.random())
            .then(response => {
                setShowLoading(false);
                if (response.statusCode == 200) {
                    getNumber();
                } else {
                    //$danger.show();
                    setErrorMessage(response.message);
                    getVarCodeImg();
                    return;
                }
            });
    };
    return (
        <div className="dialog forget" style={{ display: isShow ? 'flex' : 'none' }}>
            <div className="dialogModel">
                <div className="closeDialog" onClick={() => handleCancel()}></div>
                    
                    <div className="dialogTitle">忘记密码</div>
                    <div className="dialog-content">
                    <div className="inputDiv">
                        <Input className="input smallInput" placeholder="图形验证码" value={item.varcode2} onValidInput={handleValidInput}
                            checkRequied={true} name="varcode2" onChange={value => handleInputChange('varcode2', value)} />
                        <div className="imgDiv" onClick={getVarCodeImg}>
                            <img src={varCodeImg} className="varCode" alt="" />
                        </div>
                    </div>
                    <div className="inputDiv">
                        <Input className="input smallInput" placeholder="手机号码" value={item.phone} onValidInput={handleValidInput}
                            name="phone" onChange={value => handleInputChange('phone', value)} checkRequied={true}
                             />
                        <div className="col-right">
                            <button className={`btn-send ${item.phone && item.varcode2 && paraevent ? '' : 'btn-bgcolor'}`} onClick={sendphonecode}
                                disabled={!(item.phone && paraevent && item.varcode2)} >
                                {paracont}
                            </button>
                        </div>
                    </div>
                    <Input className="input" placeholder="短信验证码" value={item.varcode} onValidInput={handleValidInput}
                        checkRequied={true} name="varcode" onChange={value => handleInputChange('varcode', value)} />
                    <Input inputType="password" className="input" placeholder="设置密码 (6-20个字符，建议使用数字、字符、字母混合)"
                        value={item.password} minLength="6" maxLength="20" checkRequied={true} onValidInput={handleValidInput}
                        name="password" onChange={value => handleInputChange('password', value)} />
                    <Input inputType="password" className="input" placeholder="确认密码" value={item.passwordverfiy} checkRequied={true} onValidInput={handleValidInput}
                        name="passwordverfiy" onChange={value => handleInputChange('passwordverfiy', value)}
                        minLength="6" maxLength="20" />

                    <Button btnclass="login_btn " onClick={handleClick}
                        title="确&nbsp;&nbsp;定" disabled={!formIsValid } />
                        
                    </div>
            </div>

            <MessageDialog message={successMessage || errorMessage} onCancel={() => {setSuccessMessage("");
                setErrorMessage("");
            }} />
            <LoadingOverlay isLoading={isLoading } />
        </div>
    );
};

export default ForgetPasswordDialog;